import { render } from "./AutomaticNotificationsView.vue?vue&type=template&id=fd1f2800&scoped=true"
import script from "./AutomaticNotificationsView.vue?vue&type=script&lang=js"
export * from "./AutomaticNotificationsView.vue?vue&type=script&lang=js"

import "./AutomaticNotificationsView.vue?vue&type=style&index=0&id=fd1f2800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1f2800"]])

export default __exports__